export const beeSelectionMethodsEnum = Object.freeze({
  manual: 'manual',
  redList: 'redList',
  all: 'all',
});
